module.exports = __webpack_public_path__ + "static/media/3-3-trnim-korunovan.02d6abd6.jpg";